import { gql } from '@apollo/client';

const SET_PERCENTAGE_VISIBILITY_SETTINGS = gql`
  mutation SetPercentageVisibilitySettings(
    $orgUnitId: Int!
    $data: OrganizationVisibilitySettingsInput!
  ) {
    setOrganizationVisibilitySettings(orgUnitId: $orgUnitId, data: $data)
  }
`;

export default SET_PERCENTAGE_VISIBILITY_SETTINGS;
